import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import { logger } from 'rum';


const childLogger = logger;

/** maximum attempts of buffering without having seamless playback period */
const MAX_BUFFERING_ATTEMPTS = 5;
/** period (ms) of playback without returning to buffering state */
// eslint-disable-next-line no-magic-numbers
const SEAMLESS_PLAYBACK_TIMEOUT = 30 * SECOND_AS_MILLISECONDS;

class BufferingCounter {
  count: number = 0;
  lastBufferingTime: number = 0;
  onExceedMaxBufferingAttempts: () => void;

  constructor(onExceedMaxBufferingAttempts: () => void) {
    this.onExceedMaxBufferingAttempts = onExceedMaxBufferingAttempts;
  }

  reset() {
    childLogger.debug('[rewrite] BufferingCounter reset');
    this.count = 0;
    this.lastBufferingTime = 0;
  }

  countBuffering() {
    // Reset the counter if we have a seamless playback period
    if (this.lastBufferingTime && Date.now() - this.lastBufferingTime > SEAMLESS_PLAYBACK_TIMEOUT) {
      this.reset();
    // If the tab is active, we count the buffering
    } else if (!document.hidden) {
      this.count += 1;
      this.lastBufferingTime = Date.now();
      childLogger.debug(`[rewrite] BufferingCounter increment to ${this.count}`);
    }
    // Trigger the callback if we exceed the maximum attempts
    if (this.count > MAX_BUFFERING_ATTEMPTS) {
      childLogger.debug(`[rewrite] BufferingCounter more than ${MAX_BUFFERING_ATTEMPTS} attempts`);
      this.onExceedMaxBufferingAttempts();
    }
  }
}

export default BufferingCounter;
